import { useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApiClient from "@/api/Client";
import ENDPOINTS from "@/api/endpoints";
import { clearAccessToken } from "@/api/tokenManager";
import { getApiErrorMessage } from "@/utils/helper";

const LogoutDlg = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { api } = useApiClient();
  const navigate = useNavigate();

  const inFlightRef = useRef(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleLogout = async () => {
    if (inFlightRef.current) return;

    inFlightRef.current = true;
    setIsProcessing(true);
    try {
      const fcm_token = localStorage.getItem("fcm_token");
      await api.post(ENDPOINTS.AUTH.LOGOUT, { fcm_token });
      clearAccessToken();
      [
        "fcm_token",
        "hasSeenAccessibilityGuide",
        "from_explore_to_contribute",
        "update_reason",
        "profileTab",
      ].forEach((item) => localStorage.removeItem(item));

      setTimeout(() => {
        navigate("/", { replace: true });
      }, 500);

      toast.success("Logged out successfully!");
    } catch (error) {
      console.error("Error during logout:", error);
      toast.error(getApiErrorMessage(error, "Failed to logout."));
    } finally {
      setTimeout(() => {
        inFlightRef.current = false;
        setIsProcessing(false);
      }, 1000);
    }
  };

  const handleClose = () => {
    if (isProcessing) return;
    onClose && onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          p: "1%",
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "4.2vw", fontWeight: 600 }}>
        Confirm Logout
      </DialogTitle>
      <DialogContent sx={{ fontSize: "3.5vw" }}>
        Are you sure you want to log out?
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ fontSize: "3vw" }}
          onClick={handleClose}
          color="inherit"
          disabled={isProcessing}
        >
          No
        </Button>
        <Button
          sx={{ fontSize: "3vw" }}
          onClick={handleLogout}
          color="error"
          variant="contained"
          disabled={isProcessing}
        >
          {isProcessing ? "Logging out..." : "Yes, Logout"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDlg;
